// A reference can outlive the resource it points at — a deleted Practitioner still
// named as a care-team member or a diagnosis's updatedBy (#5934). Aidbox answers 404
// (never existed in this box) or 410 (soft-deleted).
//
// Kept free of imports so reference lookups (GetDisplayReferenceMixin, useGetDisplayResource)
// can use it without loading the router and stores that http.error.notifications pulls in.
export function isResourceGone(err) {
    return err?.response?.status === 404 || err?.response?.status === 410;
}
